<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/checkList')">考核列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <!-- <el-form-item label="年份">
            <el-select
              v-model="filters.year"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="2019"
                value="2019"
              ></el-option>
              <el-option
                label="2020"
                value="2020"
              ></el-option>
              <el-option
                label="2021"
                value="2021"
              ></el-option>
              <el-option
                label="2022"
                value="2022"
              ></el-option>
              <el-option
                label="2023"
                value="2023"
              ></el-option>
              <el-option
                label="2024"
                value="2024"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="考核类型">
            <el-select
              v-model="filters.infoType"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="月度考核"
                value="1"
              ></el-option>
              <el-option
                label="季度考核"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="代理类型">
            <el-select
              v-model="filters.roleType"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="康减系列市代"
                value="1.1"
              ></el-option>
              <el-option
                label="康减系列省代"
                value="2.1"
              ></el-option>
              <el-option
                label="康减系列CEO"
                value="3.1"
              ></el-option>
              <el-option
                label="市代"
                value="2"
              ></el-option>
              <el-option
                label="省代"
                value="3"
              ></el-option>
              <el-option
                label="CEO"
                value="4"
              ></el-option>
              <el-option
                label="总经销商"
                value="5"
              ></el-option>
              <el-option
                label="合伙人"
                value="2.2"
              ></el-option>
              <el-option
                label="董事"
                value="4.2"
              ></el-option>
                <el-option label="经销商" value="4.8"></el-option>
              <el-option
                label="区域总监"
                value="5.1"
              ></el-option>
              <el-option
                label="城市加盟商"
                value="5.2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              v-if="backFirst == 2"
              type="warning"
              @click="backFirstM"
            >返回返回上级</el-button>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button
              type="success"
              @click="addPostDialog"
            >新增</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          ref="dataTable"
          :data="tableData"
          style="width: 100%"
          :height="tableHeight"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="roleType"
            :formatter="formatterRoleType"
            label="代理类型"
          >
          </el-table-column>
          <el-table-column
            label="考核类型"
            :formatter="formatterInfoType"
            prop="infoType"
          >
          </el-table-column>

          <el-table-column
            label="考核时间"
            prop="fromMonth"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.infoType == 1">每月</span>
              <span v-if="scope.row.infoType == 2">{{scope.row.fromMonth}}：{{scope.row.endMonth}}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column
            label="完成金额"
            prop="finishMoney"
          >
          </el-table-column> -->

          <el-table-column
            label="目标金额"
            prop="targetMoney"
          >
          </el-table-column>

          <el-table-column
            label="考核情况"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                @click="goShowCheckRecord(scope.row)"
                type="text"
                size="small"
              >查看</el-button>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                @click="editPostDialog(scope.row)"
                type="text"
                size="small"
              >编辑</el-button>

            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="修改规则"
      :visible.sync="dialogEditVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >

        <el-form-item
          prop="roleType"
          label="代理类型"
        >
          <el-select v-model="form.roleType">
            <el-option
                label="康减系列市代"
                value="1.1"
              ></el-option>
              <el-option
                label="康减系列省代"
                value="2.1"
              ></el-option>
              <el-option
                label="康减系列CEO"
                value="3.1"
              ></el-option>
            <el-option
              label="市代"
              value="2"
            ></el-option>
            <el-option
              label="省代"
              value="3"
            ></el-option>
            <el-option
              label="CEO"
              value="4"
            ></el-option>
            <el-option
              label="总经销商"
              value="5"
            ></el-option>
            <el-option
                label="合伙人"
                value="2.2"
              ></el-option>
              <el-option
                label="董事"
                value="4.2"
              ></el-option>
                <el-option label="经销商" value="4.8"></el-option>
              <el-option
                label="区域总监"
                value="5.1"
              ></el-option>
              <el-option
                label="城市加盟商"
                value="5.2"
              ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="考核类型"
          prop='infoType'
        >
          <el-select v-model="form.infoType">
            <el-option
              label="月度考核"
              value="1"
            ></el-option>
            <el-option
              v-if="form.roleType > 2"
              label="季度考核"
              value="2"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item
          label="年份"
          prop="currentYear"
        >
          <el-select
            v-model="form.currentYear"
            placeholder="请选择"
          >
            <el-option
              label="2019"
              value="2019"
            ></el-option>
            <el-option
              label="2020"
              value="2020"
            ></el-option>
            <el-option
              label="2021"
              value="2021"
            ></el-option>
            <el-option
              label="2022"
              value="2022"
            ></el-option>
            <el-option
              label="2023"
              value="2023"
            ></el-option>
            <el-option
              label="2024"
              value="2024"
            ></el-option>

          </el-select>
        </el-form-item> -->

        <el-form-item
          v-if="form.infoType == 2"
          prop="fromMonth"
          label="开始月份"
        >
          <el-select
            v-model="form.fromMonth"
            placeholder="请选择"
          >
            <el-option
              label="1"
              value="1"
            ></el-option>
            <el-option
              label="2"
              value="2"
            ></el-option>
            <el-option
              label="3"
              value="3"
            ></el-option>
            <el-option
              label="4"
              value="4"
            ></el-option>
            <el-option
              label="5"
              value="5"
            ></el-option>
            <el-option
              label="6"
              value="6"
            ></el-option>
            <el-option
              label="7"
              value="7"
            ></el-option>
            <el-option
              label="8"
              value="8"
            ></el-option>
            <el-option
              label="9"
              value="9"
            ></el-option>
            <el-option
              label="10"
              value="10"
            ></el-option>
            <el-option
              label="11"
              value="11"
            ></el-option>
            <el-option
              label="12"
              value="12"
            ></el-option>

          </el-select>
        </el-form-item>

        <el-form-item
          v-if="form.infoType == 2"
          prop="endMonth"
          label="结束月份"
        >
          <el-select
            v-model="form.endMonth"
            placeholder="请选择"
          >
            <el-option
              label="1"
              value="1"
            ></el-option>
            <el-option
              label="2"
              value="2"
            ></el-option>
            <el-option
              label="3"
              value="3"
            ></el-option>
            <el-option
              label="4"
              value="4"
            ></el-option>
            <el-option
              label="5"
              value="5"
            ></el-option>
            <el-option
              label="6"
              value="6"
            ></el-option>
            <el-option
              label="7"
              value="7"
            ></el-option>
            <el-option
              label="8"
              value="8"
            ></el-option>
            <el-option
              label="9"
              value="9"
            ></el-option>
            <el-option
              label="10"
              value="10"
            ></el-option>
            <el-option
              label="11"
              value="11"
            ></el-option>
            <el-option
              label="12"
              value="12"
            ></el-option>

          </el-select>
        </el-form-item>

        <el-form-item
          label="目标金额"
          prop="targetMoney"
        >
          <el-input
            v-model="form.targetMoney"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请输入金额，不能输入字符串"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="editPost()"
            :loading="addLoading"
          >修改</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="新增商品分类"
      :visible.sync="dialogAddVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item
          prop="roleType"
          label="代理类型"
        >
          <el-select v-model="form.roleType">
            <el-option
              label="市代"
              value="2"
            ></el-option>
            <el-option
              label="省代"
              value="3"
            ></el-option>
            <el-option
              label="CEO"
              value="4"
            ></el-option>
            <el-option
              label="总经销商"
              value="5"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="考核类型"
          prop='infoType'
        >
          <el-select v-model="form.infoType">
            <el-option
              label="月度考核"
              value="1"
            ></el-option>
            <el-option
              v-if="form.roleType > 2"
              label="季度考核"
              value="2"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="年份"
          prop="currentYear"
        >
          <el-select
            v-model="form.currentYear"
            placeholder="请选择"
          >
            <el-option
              label="2019"
              value="2019"
            ></el-option>
            <el-option
              label="2020"
              value="2020"
            ></el-option>
            <el-option
              label="2021"
              value="2021"
            ></el-option>
            <el-option
              label="2022"
              value="2022"
            ></el-option>
            <el-option
              label="2023"
              value="2023"
            ></el-option>
            <el-option
              label="2024"
              value="2024"
            ></el-option>

          </el-select>
        </el-form-item>

        <el-form-item
          v-if="form.infoType == 2"
          prop="fromMonth"
          label="开始月份"
        >
          <el-select
            v-model="form.fromMonth"
            placeholder="请选择"
          >
            <el-option
              label="1"
              value="1"
            ></el-option>
            <el-option
              label="2"
              value="2"
            ></el-option>
            <el-option
              label="3"
              value="3"
            ></el-option>
            <el-option
              label="4"
              value="4"
            ></el-option>
            <el-option
              label="5"
              value="5"
            ></el-option>
            <el-option
              label="6"
              value="6"
            ></el-option>
            <el-option
              label="7"
              value="7"
            ></el-option>
            <el-option
              label="8"
              value="8"
            ></el-option>
            <el-option
              label="9"
              value="9"
            ></el-option>
            <el-option
              label="10"
              value="10"
            ></el-option>
            <el-option
              label="11"
              value="11"
            ></el-option>
            <el-option
              label="12"
              value="12"
            ></el-option>

          </el-select>
        </el-form-item>

        <el-form-item
          v-if="form.infoType == 2"
          prop="endMonth"
          label="结束月份"
        >
          <el-select
            v-model="form.endMonth"
            placeholder="请选择"
          >
            <el-option
              label="1"
              value="1"
            ></el-option>
            <el-option
              label="2"
              value="2"
            ></el-option>
            <el-option
              label="3"
              value="3"
            ></el-option>
            <el-option
              label="4"
              value="4"
            ></el-option>
            <el-option
              label="5"
              value="5"
            ></el-option>
            <el-option
              label="6"
              value="6"
            ></el-option>
            <el-option
              label="7"
              value="7"
            ></el-option>
            <el-option
              label="8"
              value="8"
            ></el-option>
            <el-option
              label="9"
              value="9"
            ></el-option>
            <el-option
              label="10"
              value="10"
            ></el-option>
            <el-option
              label="11"
              value="11"
            ></el-option>
            <el-option
              label="12"
              value="12"
            ></el-option>

          </el-select>
        </el-form-item>

        <el-form-item
          v-if="form.infoType == 1"
          prop="inMonth"
          label="考核月份"
        >
          <el-select
            v-model="form.inMonth"
            placeholder="请选择"
          >
            <el-option
              label="1"
              value="1"
            ></el-option>
            <el-option
              label="2"
              value="2"
            ></el-option>
            <el-option
              label="3"
              value="3"
            ></el-option>
            <el-option
              label="4"
              value="4"
            ></el-option>
            <el-option
              label="5"
              value="5"
            ></el-option>
            <el-option
              label="6"
              value="6"
            ></el-option>
            <el-option
              label="7"
              value="7"
            ></el-option>
            <el-option
              label="8"
              value="8"
            ></el-option>
            <el-option
              label="9"
              value="9"
            ></el-option>
            <el-option
              label="10"
              value="10"
            ></el-option>
            <el-option
              label="11"
              value="11"
            ></el-option>
            <el-option
              label="12"
              value="12"
            ></el-option>

          </el-select>
        </el-form-item>

        <!-- <el-form-item
          label="完成金额"
          prop="finishMoney"
        >
          <el-input
            v-model="form.finishMoney"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请输入金额，不能输入字符串"
          ></el-input>
        </el-form-item> -->

        <el-form-item
          label="目标金额"
          prop="targetMoney"
        >
          <el-input
            v-model="form.targetMoney"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            placeholder="请输入金额，不能输入字符串"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="addPost()"
            :loading="addLoading"
          >新增</el-button>
          <el-button @click="dialogAddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
export default {
  name: "checkList",
  created() {},

  data() {
    return {
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      addFormRule: {
        roleType: [
          { required: true, message: "请选择角色类型", trigger: "blur" }
        ],
        infoType: [
          { required: true, message: "请选择考核 类型", trigger: "blur" }
        ],
        currentYear: [
          { required: true, message: "请选择考核年份", trigger: "blur" }
        ],
        // finishMoney: [
        //   { required: true, message: "请填写完成金额", trigger: "blur" }
        // ],
        targetMoney: [
          { required: true, message: "请填写目标金额", trigger: "blur" }
        ]
      },
      addLoading: false,
      loading: false,
      form: {
        roleType: null,
        infoType: null,
        fromMonth: null,
        endMonth: null,
        inMonth: null,
        currentYear: null,
        finishMoney: null,
        targetMoney: null,
        id: null
      },
      dialogPics: [],
      dialogEditVisible: false,
      dialogContent: "",
      dialogTitle: "",
      dialogVisible: false,
      filters: {
        roleType: null,
        infoType:null,
        year: null,
        pid: null
      },
      isCollapse: true,
      activeName: "second",
      dialogAddVisible: false,
      backFirst: 1,
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: [{ text: "待上架", value: "1" }, { text: "上架", value: "2" }],
      typeOptions: null,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    goShowCheckRecord(row){
      this.$router.push({ path: "/checkRecord", query: { good: row } });
    },
    formatterRoleType(row, column) {
      if (row.roleType == -1) {
        return "无";
      } else if (row.roleType == -0.5) {
        return "康减系列VIP会员";
      } else if (row.roleType == -0.4) {
        return "康减系列荣誉会员";
      } else if (row.roleType == -0.3) {
        return "康减系列高级会员";
      } else if (row.roleType == 0) {
        return "VIP门店";
      } else if (row.roleType == 1) {
        return "联盟店";
      } else if (row.roleType == 1.05) {
        return "优秀联盟店";
      } else if (row.roleType == 2) {
        return "市代";
      } else if (row.roleType == 3) {
        return "省代";
      } else if (row.roleType == 4) {
        return "CEO";
      } else if (row.roleType == 1.1) {
        return "康减系列市代";
      } else if (row.roleType == 2.1) {
        return "康减系列省代";
      } else if (row.roleType == 3.1) {
        return "康减系列CEO";
      } else if (row.roleType == 5) {
        return "总经销商";
      } else if (row.roleType == 2.2) {
        return "合伙人";
      } else if (row.roleType == 4.2) {
        return "董事";
      } else if (row.roleType == 5.1) {
        return "区域总监";
      } else if (row.roleType == 5.2) {
        return "城市加盟商";
      } else if (row.roleType == 4.8) {
        word =  "经销商";
      }
    },
    formatterInfoType(row, column) {
      if (row.infoType == 1) {
        return "月度考核";
      } else if (row.infoType == 2) {
        return "季度考核";
      }
    },
    beforeAvatarUpload: function(e) {},
    beforeAvatarUpload1: function(e) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.listPic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess1: function(e) {
      if (e.key == 1000) {
        this.form.mainPic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    addPost() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          if (para.infoType == 1) {
            if (para.inMonth == null) {
              that.$message.error({
                showClose: true,
                message: "请选择考核月份",
                duration: 2000
              });
              return;
            }
          } else if (para.infoType == 2) {
            if (para.fromMonth == null || para.endMonth == null) {
              that.$message.error({
                showClose: true,
                message: "请选择起始月份",
                duration: 2000
              });
              return;
            }
          }
          that.addLoading = true;
          API.up_check_role(para)
            .then(
              function(result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 1500
                  });
                  that.dialogAddVisible = false;
                  that.addLoading = false;
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.dialogAddVisible = false;
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.dialogAddVisible = false;
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    editPost() {
      var that = this;
      let para = Object.assign({}, that.form);
      para.token = localStorage.getItem("api_token");
      if (para.infoType == 1) {
        if (para.inMonth == null) {
          that.$message.error({
            showClose: true,
            message: "请选择考核月份",
            duration: 2000
          });
          return;
        }
      } else if (para.infoType == 2) {
        if (para.fromMonth == null || para.endMonth == null) {
          that.$message.error({
            showClose: true,
            message: "请选择起始月份",
            duration: 2000
          });
          return;
        }
      }
      this.addLoading = true;
      API.up_check_role(para)
        .then(
          function(result) {
            if (result.key == 1000) {
              that.$message.success({
                showClose: true,
                message: "修改成功",
                duration: 1500
              });
              that.dialogEditVisible = false;
              that.addLoading = false;
              that.search();
            } else if (result.key == 1001) {
              bus.$emit("goto", "/login");
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "登录失败",
                duration: 2000
              });
            }
          },
          function(err) {
            that.dialogEditVisible = false;
            that.addLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.dialogEditVisible = false;
          that.addLoading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    addPostDialog() {
      this.form.targetMoney = null;
      this.form.finishMoney = null;
      this.form.infoType = "1";
      this.form.roleType = "2";
      this.form.fromMonth = null;
      this.form.endMonth = null;
      this.form.inMonth = null;

      this.dialogAddVisible = true;
    },
    backFirstM() {
      this.backFirst = 1;
      this.filters.pid = null;
      this.handleSearch();
    },
    showSecond(row) {
      this.backFirst = 2;
      this.filters.pid = row.id;
      this.handleSearch();
    },
    editPostDialog(row) {
      this.form.id = row.id;
      this.form.fromMonth =
        row.fromMonth == null ? "1" : row.fromMonth.toString();
      this.form.endMonth = row.endMonth == null ? "1" : row.endMonth.toString();
      this.form.inMonth = row.inMonth == null ? "1" : row.inMonth.toString();
      // this.form.finishMoney = row.finishMoney;
      this.form.targetMoney = row.targetMoney;
      this.form.id = row.id;
      this.form.currentYear = row.currentYear;
      this.form.roleType = row.roleType.toString();
      this.form.infoType = row.infoType.toString();
      this.dialogEditVisible = true;
    },
    upHouseStatus(row, status) {
      let that = this;
      var m1 = "";
      var m2 = "";
      var m3 = "";
      var type = "";
      if (status == 1) {
        m1 = "确定取消上架该商品分类吗？";
        m2 = "取消成功后，app就不显示该分类";
        m3 = "取消成功";
        type = "warning";
      } else if (status == 2) {
        m1 = "确定上架该商品分类吗？";
        m2 = "上架成功后，app就会显示该分类";
        m3 = "上架成功";
        type = "success";
      } else {
        m1 = "确定删除该考核规则吗？";
        m2 = "删除成功后，app和后台都不显示该考核";
        m3 = "删除成功";
        type = "error";
      }
      this.$confirm(m1, m2, { type: type })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id
          };
          API.del_check_rule(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  if (para.status == 3) {
                    that.typeOptions = null;
                  }
                  that.$message.success({
                    showClose: true,
                    message: m3,
                    duration: 1500
                  });
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;

      let params = {
        page_num: that.page_num,
        page_size: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.roleType) {
        params.roleType = that.filters.roleType;
      }
      if (that.filters.infoType) {
        params.infoType = that.filters.infoType;
      }
      that.loading = true;

      API.check_rule_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
              }
              that.tableData = result.result.list;
            } else if (result.key == 1001) {
              bus.$emit("goto", "/login");
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/checkList.vue